import type {
  DoubleValue,
  FloatValue,
  Int64Value,
  UInt64Value,
  Int32Value,
  UInt32Value,
  BoolValue,
  StringValue,
  BytesValue,
} from "../../google/protobuf/wrappers.types";
import { Reader, Writer } from "protobufjs/minimal";
import type { Long } from "protoc-gen-ts";

export const createBaseDoubleValue = (): DoubleValue => {
  return {
    value: 0,
  };
};

export const decodeDoubleValue = (
  reader: Reader,
  length: number
): DoubleValue => {
  const end = reader.pos + length;
  const message = createBaseDoubleValue();

  while (reader.pos < end) {
    const tag = reader.uint32();
    switch (tag >>> 3) {
      case 1:
        message.value = reader.double();

        break;

      default:
        reader.skipType(tag & 7);
        break;
    }
  }

  return message;
};

export const encodeDoubleValue = (
  writer: Writer,
  message: DoubleValue
): Writer => {
  writer.uint32(9).double(message.value);

  return writer;
};

export const createBaseFloatValue = (): FloatValue => {
  return {
    value: 0,
  };
};

export const decodeFloatValue = (
  reader: Reader,
  length: number
): FloatValue => {
  const end = reader.pos + length;
  const message = createBaseFloatValue();

  while (reader.pos < end) {
    const tag = reader.uint32();
    switch (tag >>> 3) {
      case 1:
        message.value = reader.float();

        break;

      default:
        reader.skipType(tag & 7);
        break;
    }
  }

  return message;
};

export const encodeFloatValue = (
  writer: Writer,
  message: FloatValue
): Writer => {
  writer.uint32(13).float(message.value);

  return writer;
};

export const createBaseInt64Value = (): Int64Value => {
  return {
    value: 0,
  };
};

export const decodeInt64Value = (
  reader: Reader,
  length: number
): Int64Value => {
  const end = reader.pos + length;
  const message = createBaseInt64Value();

  while (reader.pos < end) {
    const tag = reader.uint32();
    switch (tag >>> 3) {
      case 1:
        message.value = (reader.int64() as Long).toNumber();

        break;

      default:
        reader.skipType(tag & 7);
        break;
    }
  }

  return message;
};

export const encodeInt64Value = (
  writer: Writer,
  message: Int64Value
): Writer => {
  writer.uint32(8).int64(message.value);

  return writer;
};

export const createBaseUInt64Value = (): UInt64Value => {
  return {
    value: 0,
  };
};

export const decodeUInt64Value = (
  reader: Reader,
  length: number
): UInt64Value => {
  const end = reader.pos + length;
  const message = createBaseUInt64Value();

  while (reader.pos < end) {
    const tag = reader.uint32();
    switch (tag >>> 3) {
      case 1:
        message.value = (reader.uint64() as Long).toNumber();

        break;

      default:
        reader.skipType(tag & 7);
        break;
    }
  }

  return message;
};

export const encodeUInt64Value = (
  writer: Writer,
  message: UInt64Value
): Writer => {
  writer.uint32(8).uint64(message.value);

  return writer;
};

export const createBaseInt32Value = (): Int32Value => {
  return {
    value: 0,
  };
};

export const decodeInt32Value = (
  reader: Reader,
  length: number
): Int32Value => {
  const end = reader.pos + length;
  const message = createBaseInt32Value();

  while (reader.pos < end) {
    const tag = reader.uint32();
    switch (tag >>> 3) {
      case 1:
        message.value = reader.int32();

        break;

      default:
        reader.skipType(tag & 7);
        break;
    }
  }

  return message;
};

export const encodeInt32Value = (
  writer: Writer,
  message: Int32Value
): Writer => {
  writer.uint32(8).int32(message.value);

  return writer;
};

export const createBaseUInt32Value = (): UInt32Value => {
  return {
    value: 0,
  };
};

export const decodeUInt32Value = (
  reader: Reader,
  length: number
): UInt32Value => {
  const end = reader.pos + length;
  const message = createBaseUInt32Value();

  while (reader.pos < end) {
    const tag = reader.uint32();
    switch (tag >>> 3) {
      case 1:
        message.value = reader.uint32();

        break;

      default:
        reader.skipType(tag & 7);
        break;
    }
  }

  return message;
};

export const encodeUInt32Value = (
  writer: Writer,
  message: UInt32Value
): Writer => {
  writer.uint32(8).uint32(message.value);

  return writer;
};

export const createBaseBoolValue = (): BoolValue => {
  return {
    value: false,
  };
};

export const decodeBoolValue = (reader: Reader, length: number): BoolValue => {
  const end = reader.pos + length;
  const message = createBaseBoolValue();

  while (reader.pos < end) {
    const tag = reader.uint32();
    switch (tag >>> 3) {
      case 1:
        message.value = reader.bool();

        break;

      default:
        reader.skipType(tag & 7);
        break;
    }
  }

  return message;
};

export const encodeBoolValue = (writer: Writer, message: BoolValue): Writer => {
  writer.uint32(8).bool(message.value);

  return writer;
};

export const createBaseStringValue = (): StringValue => {
  return {
    value: "",
  };
};

export const decodeStringValue = (
  reader: Reader,
  length: number
): StringValue => {
  const end = reader.pos + length;
  const message = createBaseStringValue();

  while (reader.pos < end) {
    const tag = reader.uint32();
    switch (tag >>> 3) {
      case 1:
        message.value = reader.string();

        break;

      default:
        reader.skipType(tag & 7);
        break;
    }
  }

  return message;
};

export const encodeStringValue = (
  writer: Writer,
  message: StringValue
): Writer => {
  writer.uint32(10).string(message.value);

  return writer;
};

export const createBaseBytesValue = (): BytesValue => {
  return {
    value: new Uint8Array(),
  };
};

export const decodeBytesValue = (
  reader: Reader,
  length: number
): BytesValue => {
  const end = reader.pos + length;
  const message = createBaseBytesValue();

  while (reader.pos < end) {
    const tag = reader.uint32();
    switch (tag >>> 3) {
      case 1:
        message.value = reader.bytes();

        break;

      default:
        reader.skipType(tag & 7);
        break;
    }
  }

  return message;
};

export const encodeBytesValue = (
  writer: Writer,
  message: BytesValue
): Writer => {
  writer.uint32(10).bytes(message.value);

  return writer;
};
